import React, { useState } from "react";
import HTMLParser from "../../htmlParser";
const Definitions = (props) => {
    const [isOpen, setOpen] = useState(false);
    const seeMore = typeof props.attributes.seeMore === "undefined" ||
        props.attributes.seeMore === true;
    return (React.createElement("dl", { className: (isOpen ? "open" : "closed") +
            " definitions wp-block-gco-locked-group-definitions " +
            (seeMore ? "seemore" : "seeall") },
        React.createElement(HTMLParser, null, props.innerBlocks.map((e) => e.outerHTML).join("")),
        seeMore ? (React.createElement("div", null,
            React.createElement("button", { onClick: () => {
                    setOpen((value) => !value);
                } },
                "Voir ",
                isOpen ? "moins" : "plus",
                " de d\u00E9tails"))) : (React.createElement(React.Fragment, null))));
};
export default Definitions;
